module.exports = __webpack_public_path__ + "static/media/logo.07fda048.svg";